import React from 'react'
import "../../CSS/Blog/Pysms.css"
import FooTer from "../footer"
import pysms from "../../Projects/Blog/whatsapp.py"

export default function Waunsms() {
    return (
        <>
            <h1 id="start">Sending Unlimited SMS With Python!</h1>
            <hr />
            <p className="hd">In This Video How To Send Python Unlimited Sms With Pyautogui</p>
            <div className="phishing-yt">
                <iframe id="yt" src="https://www.youtube.com/embed/oVZa3gwtvsQ" title="YouTube video player" frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen></iframe>
            </div>
            <div className="yt-visit">
                <p id="sub">
                    If You Guys Injoy My Video So Visit My Youtube Channel:
                </p>
                <a id="cd" href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg" rel='noreferrer' target="_blank"><button>Code
                    Arindam</button></a>
            </div>
            <p className="ans">
                In This Video Using: <br />
                <br />
                1) Python<br />
                2) Pyautogui Module<br />
                3) Time Module<br />
            </p>
            <p className="q">
                Suprise Your Friends!
            </p>
            <p className="ans">
                Pyautogui is a module of python. That module will help you to do some tricks fun just like here one we send
                unlimited sms on same time in whatsapp so Let's Go.
            </p>
            <p className="q">
                How To install Pyautogui Module?
            </p>
            <p className="ans">
                pip install pyautogui
            </p>
            <p className="q">
                Copy The Below Code...
            </p>
            <div className="py-un">
                <code lang="python">
                    import pyautogui as pg <br />
                    import time <br />
                    <br />
                    time.sleep(5) <br />
                    <br />
                    # Using For Loop <br />
                    <br />
                    for i in range(10): <br />
                    pg.typewrite("How Are You") <br />
                    pg.press("Enter") <br />
                    <br />
                    # Using While Loop <br />
                    <br />
                    i = 0 <br />
                    while (i=5): <br />
                    pg.typewrite("Hi" + str(i)) <br />
                    pg.press("Enter") <br />
                    <br />
                    i = i +1 <br />
                </code>
            </div>
            <p className="q">
                :: DOWNLOAD PYTHON FILE ONLY ::
            </p>
            <div className="zip-downloader">
                <button id="zip"><a href={pysms}>DOWNLOAD</a></button>
            </div>
            <p className="last">
                So Hope You Guys Injoy This Video And So Be Carefull And Stay Helthy And Have A Great Day...
            </p>
            <FooTer/>
        </>
    )
}
